import React from 'react';

import ScheduleListItems from './scheduleListItems';

const ScheduleList = ({ ...props }) => {
    const onButtonClickedHandler = i => {
        const item = props.items[i];
        props.onButtonClick(i, item);
    };

    return (
        <div className={props.className}>
            {props.header ? <h2>{props.header}</h2> : ''}
            <ScheduleListItems
                hideButtons={props.hideButtons}
                hideDate={props.hideDate}
                items={props.items}
                onButtonClick={i => {
                    onButtonClickedHandler(i);
                }}
            />
        </div>
    );
};

export default ScheduleList;
